import * as React from 'react';
import { PostHogProvider } from 'posthog-js/react';
import { PostHogConfig } from 'posthog-js';

interface PostHogClientProviderProps {
  apiKey?: string;
  options?: Partial<PostHogConfig>;
  children: React.ReactNode;
}

/**
 * Client-side only PostHog provider wrapper
 * Prevents PostHog from initializing during server-side rendering
 */
export const PostHogClientProvider: React.FunctionComponent<PostHogClientProviderProps> = ({
  apiKey,
  options,
  children,
}) => {
  // During SSR, don't initialize PostHog
  if (typeof window === 'undefined') {
    return children as React.ReactElement;
  }

  // Only render PostHogProvider on the client side if apiKey is available
  if (!apiKey) {
    return children as React.ReactElement;
  }

  return (
    <PostHogProvider apiKey={apiKey} options={options}>
      {children}
    </PostHogProvider>
  );
};
